import { render, staticRenderFns } from "./StepPlusOne.vue?vue&type=template&id=a4838f22"
import script from "./StepPlusOne.vue?vue&type=script&lang=js"
export * from "./StepPlusOne.vue?vue&type=script&lang=js"
import style0 from "./StepPlusOne.vue?vue&type=style&index=0&id=a4838f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports